import { createRoute, redirect } from '@tanstack/react-router';
// fallow-ignore-next-line circular-dependency
import { Route as pathlessAuthenticatedRoute } from '../../route';

/** Legacy URL; the nav tab is now Metrics at /accounts-payable/metrics. */
export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/accounts-payable/throughput',
  beforeLoad: () => {
    throw redirect({ to: '/accounts-payable/metrics', search: true });
  },
});
